import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=151dc18f&scoped=true"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"
import style0 from "./Chart.vue?vue&type=style&index=0&id=151dc18f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151dc18f",
  null
  
)

export default component.exports